import { render, staticRenderFns } from "./OrganizationalUnit.vue?vue&type=template&id=66d441b4&"
import script from "./OrganizationalUnit.vue?vue&type=script&lang=js&"
export * from "./OrganizationalUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d441b4')) {
      api.createRecord('66d441b4', component.options)
    } else {
      api.reload('66d441b4', component.options)
    }
    module.hot.accept("./OrganizationalUnit.vue?vue&type=template&id=66d441b4&", function () {
      api.rerender('66d441b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/OrganizationalUnit.vue"
export default component.exports